export const loadLandingView = () => import("./views/landing.view");
